module.exports = __webpack_public_path__ + "static/All-inclusiveStructure-fccf86411665c52df269a1202f476c6b.jpg";